function consent(text,dismiss,info,hide,url,age){

	/*get timestamps*/
	var unix = Math.round((new Date()).getTime() / 1000);
	var expire = age*24*60*60;

	/*if not set or deprecated*/
	if(
		(localStorage['cookie_consent'] == null) ||
		((localStorage['cookie_consent'] != '') && (localStorage['cookie_consent'] < unix-expire))
	){

		/*show notification*/
		var cookie = document.createElement('div');
		cookie.className = 'cookie';
		cookie.innerHTML = '<p>'+text+'</p><span class="box"><a href="'+url+'" target="_blank">'+info+'</a><a class="dismiss">'+dismiss+'</a><a class="hide">'+hide+'</a></span>';
		document.body.appendChild(cookie);

	}else{

		/*tracking already enabled, so track*/
		optin();

	}

	/*dismiss*/
	document.addEventListener('click', function(event){

		if(event.target.classList.contains('dismiss')){
			localStorage['cookie_consent'] = unix;
			optin();
			gtag('event', 'consent_click');
			document.querySelector('.cookie').remove();
		}

		if(event.target.classList.contains('hide')){
			document.querySelector('.cookie').remove();
		}

	});

}



/*tracking*/
var trackingId = 'GTM-TS484MR9';
window.dataLayer = window.dataLayer || [];
function gtag(){
	dataLayer.push(arguments);
}

function optin(){

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'gtm.start': new Date().getTime(),
		event: 'gtm.js'
	});

	var firstScript = document.getElementsByTagName('script')[0];
	var script = document.createElement('script');
	var dataLayerName = '';
	script.async = true;
	script.src = 'https://www.googletagmanager.com/gtm.js?id='+trackingId+dataLayerName;
	firstScript.parentNode.insertBefore(script, firstScript);

	gtag('consent', 'default', {
		'ad_storage': 'denied',
		'ad_user_data': 'denied',
		'ad_personalization': 'denied',
		'analytics_storage': 'denied',
		'personalization_storage': 'denied',
		'security_storage': 'granted'
	});

	gtag('consent', 'update', {
		'ad_storage': 'granted',
		'ad_user_data': 'granted',
		'ad_personalization': 'granted',
		'analytics_storage': 'granted',
		'personalization_storage': 'granted',
		'security_storage': 'granted'
	});

	console.log('tracking');

}
